import { render, staticRenderFns } from "./PlanProposalSummary.vue?vue&type=template&id=54091d28&"
import script from "./PlanProposalSummary.vue?vue&type=script&lang=js&"
export * from "./PlanProposalSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports